let logoutInProgress = false;

type Listener = (state: boolean) => void;

const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((listener) => listener(logoutInProgress));
};

const setLogoutState = (state: boolean) => {
  logoutInProgress = state;
  notify();
};

export const beginLogout = () => {
  setLogoutState(true);
};

export const endLogout = () => {
  setLogoutState(false);
};

export const isLogoutInProgress = () => logoutInProgress;

export const subscribeToLogoutState = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
